import React, { Component, createRef } from 'react';
import parse from 'html-react-parser';
// import '/node_modules/bootstrap/dist/css/bootstrap.min.css';
import './App.css';
// import data from './data/demodata.json';
import Question from './components/question';
import Answer from './components/answer';
import Result from './components/result';
import ReactGA from 'react-ga4';
// const TRACKING_ID = "G-XXXXXXXXXX";

class App extends Component {

    state = {
        // theme: 'hasit',
        dataLoaded: false,
        appData: '',
        start: true,
        error: false,
        popUp: '',
        popHeight: 0,
        acceptTerms: false,
        questions: [],
        path: [],
        result: false,
        resultData: [],
        dataString: '[0][_children]',
        // dataTable: data[0]['_children'],
        dataTable: '',
        dataTableInit: '',
        view: 'QA',
        rowHeight: '',
        ignoreParams: false,
    }

    getArrayByStringName = (array, name) => {
        // Splitting the string into parts
        const parts = name.split(/[[\]']+/).filter(Boolean);

        // Iterating through the parts to access the array
        let result = array;
        for (let part of parts) {
          if (part in result) {
            result = result[part];
          } else {
            // Error handling for the case where the name is invalid
            console.error(`Part '${part}' not found in the array.`);
            return null;
          }
        }
        return result;
      }

    goToStart = () => {
        this.setState({
            start: true,
            questions: [],
            path: [],
            result: false,
            resultData: [],
            dataString: '[0][_children]',
            dataTable: this.state.dataTableInit,
            view: 'QA'
        })

        const params = new URLSearchParams(window.location.search);
        params.delete('a');
        params.delete('p');
        window.history.pushState({},'','?'+params)
    }

    findObject = (collection, key, value) => {
        for (const o of collection) {
            for (const [k, v] of Object.entries(o)) {
                if (k === key && v === value) {
                    return o
                }
                if (Array.isArray(v)) {
                    const _o = this.findObject(v, key, value)
                    if (_o) {
                        return _o
                    }
                }
            }
        }
    }

    findTree = (tree,target, arr) => {
        if(tree.uid === target)
        {
            arr.push([
                tree.uid,
                tree.title,
                tree.__type,
                tree.nav_title
            ]);
            return true;
        }
        if(tree._children == null){
            return false;
        }

        let n = tree._children.length;
        for(let i = 0;i < n;i++){
            
            arr.push([
                tree.uid,
                tree.title,
                tree.__type,
                tree.nav_title
            ]);
            if(this.findTree(tree._children[i],target,arr))
                return true;
            arr.pop();
        }

        return false;
    }

    componentDidMount() {
        // ReactGA.initialize([
        //     {
        //       trackingId: TRACKING_ID,
        //     //   testMode: true
        //     }
        // ])
        // ReactGA.send("pageview");

        // if cookie-Terms
        if (sessionStorage.getItem("acceptTerms")) {
            this.setState({ acceptTerms: true })
        }

        // console.log( this.props.dataPid )
        const urlSearchString = window.location.search;
        const params = new URLSearchParams(urlSearchString);

        const url = `${this.props.host}?id=${this.props.dataPid}&tx_fixitgruppe_productfindertreejson[pageUid]=${this.props.dataPid}&type=1702386624`

        // console.log(url);
        fetch(url)
        .then((response) => response.json())
        .then((data) => {
            this.setState({ data: data })
            this.setState({ dataTable: data[0]['_children'] })
            this.setState({ dataTableInit: data[0]['_children'] })
            this.setState({ appData: data[1] })
            this.setState({ dataLoaded: true })

            if (params.size !== 0) {
                // console.log(params)
                if (params.get('p')){
                    let aUid = Number.parseInt(params.get('a'))
                    
                    this.setState({ result: true })
                    this.setState({ answer: aUid });
                }
                if (params.get('a')){
                    let aUid = Number.parseInt(params.get('a'))
    
                    let arr = [];
                    this.findTree(data[0]['_children'][0], aUid, arr);
                    // console.log(arr);
                    let filteredArr = arr.filter(function(value, index) {
                        return (index + 1) % 2 !== 0;
                    });

                    let filteredArrPath = []
                    if (params.get('p')){
                        // console.log('test')
                        filteredArrPath = arr
                    } else {
                        filteredArrPath = arr.slice(0,-1);
                    }
                        
                    // console.log(filteredArrPath)
                    if (filteredArr.length === 0) {
                        console.log('Fehler')
                        this.setState({ start: true })
                        this.setState({ error: true })
                        this.setState({ view: 'QA' })
                        this.setState({ result: false })
                    } else {
                        // console.log(filteredArr)
                        this.setState({ questions: filteredArr })
                        this.setState({ path: filteredArrPath })
                        this.setState({ start:false })

                        // let qUid = filteredArr.pop();
                        let qUid = filteredArr[filteredArr.length - 1][0];
                        let objArr = [];
                        let obj = this.findObject(data[0]['_children'], 'uid', qUid)
                        objArr.push(obj);
                        // console.log(filteredArr);
                        this.setState({ dataTable: objArr })

                        if (!params.get('p')){
                            filteredArr.pop()
                        }
                    }
                }
                if (this.state.acceptTerms === true) {
                    // console.log('true')
                } else {
                    this.setState({
                        start: true,
                        popUp: 'open'
                    })
                }
            }
        })
        .catch((error) => {
            // console.log(error);
            this.setState({ error: true })
        });
        
    }

    addQuestion = (qUid, aUid) => {

        let qObj = this.findObject(this.state.dataTable, 'uid', qUid);
        let aObj = this.findObject(this.state.dataTable, 'uid', aUid);

        // Card-Höhe zurücksetzen
        this.setState({ rowHeight: 0 })

        // Fehlermeldung von Parameter entfernen
        this.setState({ error: false })

        // Path
        let currentPath = this.state.path;
        // console.log(currentPath)
        let existPath = this.state.path.find(question => question === qUid);
        if (existPath) {
            // nothing to do
        } else {
            currentPath.push([
                qUid,
                qObj.title,
                qObj.__type,
                qObj.nav_title
            ]);
            currentPath.push([
                aUid,
                aObj.title,
                aObj.__type,
            ]);
            // currentQuestion.push(aUid);
        }
        this.setState({ path: currentPath });

        // Path to Navigate
        let currentQuestion = this.state.questions;
        //console.log(this.state.questions)
        let existQuestion = this.state.questions.find(question => question === qUid);
        if (existQuestion) {
            // nothing to do
        } else {
            currentQuestion.push([
                qUid,
                qObj.title,
                qObj.__type,
                qObj.nav_title
            ]);
            // currentQuestion.push(aUid);
        }
        this.setState({ questions: currentQuestion });
        
        // Switch to next Question
        let objArr = [];
        let obj = this.findObject(this.state.dataTable, 'uid', aUid);
        objArr.push(obj);
        // console.log(objArr);

        // TRACKING
        let step = this.state.questions.length + 1;
        let question = this.findObject(this.state.dataTable, 'uid', qUid);
        let selection = this.findObject(this.state.dataTable, 'uid', aUid);
        // console.log('product_finder_selection');
        // console.log('step: ' + step);
        // console.log('question: ' + question.title + '');
        // console.log('selection: ' + selection.title + '');
        ReactGA.event('product_finder_selection', {
            'step': step,
            'question': question.title,
            'selection': selection.title
        });
        
        let resultArray = objArr[0]['_children'];
        if (resultArray.length) {
            // console.log(resultArray);
            this.setState({ result: false });
            this.setState({ dataTable: resultArray });
            this.setState({ view: 'QA' });
            
            // console.log(resultArray[0]['uid'])
            const params = new URLSearchParams(window.location.search);
            params.set('a', resultArray[0]['uid']);
            params.delete('p');
            window.history.pushState({},'','?'+params)
        } else {
            // console.log('leer');
            this.setState({ result: true });
            this.setState({ answer: aUid });
            this.setState({ view: 'RL' });
            this.setState({ ignoreParams: true })

            // TRACKING
            // console.log('product_finder_end');
            ReactGA.event('product_finder_end');
        }
    }

    jumpToQuestion = (qUid,i) => {

        // Card-Höhe zurücksetzen
        this.setState({ rowHeight: 0 })

        // console.log(this.state.questions)
        // console.log(i);
        
        // Switch to Question
        // let resultArray = this.getArrayByStringName(this.state.data, path);
        let objArr = [];
        let obj = this.findObject(this.state.dataTableInit, 'uid', qUid);
        objArr.push(obj);
        // console.log(objArr);
        
        let resultArray = objArr;
        // console.log(objArr);
        if (resultArray.length) {
            this.setState({ result: false });
            // this.setState({ dataString: qUid });
            this.setState({ dataTable: resultArray });
        } else {
            this.setState({ view: 'RL' })
        }

        // Update this.state.path
        let statePathArray = this.state.path;
        const newPathArray = statePathArray.slice(0,i*2);
        this.setState({ path: newPathArray });
        
        // Update this.state.questions
        let stateQArray = this.state.questions;
        const newQArray = stateQArray.slice(0,i);        
        this.setState({ questions: newQArray });
        // console.log(this.state.questions);

        this.setState({ view: 'QA' })

        const params = new URLSearchParams(window.location.search);
        params.set('a', qUid);
        params.delete('p');
        window.history.pushState({},'','?'+params)
    }

    updateView = (newValue) => {
        this.setState({ view: newValue });
    }

    changeView = (newValue) => {
        this.setState({ view: newValue });
        // Card-Höhe zurücksetzen
        this.setState({ rowHeight: 0 })

        if (newValue === 'RL') {
            const params = new URLSearchParams(window.location.search);
            params.set('p', '0');
            window.history.pushState({},'','?'+params)
        }
    };

    updateHeight = (newValue, index, firstCardH) => {
        if (index >= 3){
            this.setState({ rowHeight: newValue + firstCardH + 30});
        } else {
            this.setState({ rowHeight: newValue });
        }
    }

    openPopUp = () => {
        this.setState({ popUp: 'open' });

        this.popup = createRef();
        setTimeout(() => {
            let popHeight = this.popup.current.offsetHeight;
            this.setState({ popHeight: popHeight + 20 });
            console.log(popHeight)
        }, 500);
    };

    start = () => {
        this.setState({
            start:false,
            acceptTerms:true,
            popUp:'',
            error:false,
            popHeight: 0
        })

        // set Cookie-Terms
        sessionStorage.setItem("acceptTerms", true);

        const params = new URLSearchParams(window.location.search);        
        if (params.size === 0) {
            let data = this.state.dataTableInit
            params.set('a', data[0]['uid']);
            window.history.pushState({},'','?'+params)
        }

        // TRACKING
        if (this.state.popUp !== '') {
            //console.log('Klick-acceptTerms');
        } else {
            // console.log('product_finder_start');
            ReactGA.event('product_finder_start');
        }
    }

    render() {
        const divHeight = {
            minHeight: this.state.rowHeight + 30
        };
        return (
            <div className={'App theme-' + this.state.appData.brand}>
                <div className='container'>
                    {this.state.dataLoaded ? (
                        <div className='row'>
                            {this.state.error 
                                ? <div className='col-12 text-center error-message'><p>&nbsp;</p><p>{this.state.appData.productfinder_error}</p></div>
                                : ''
                            }
                            <div className='col-12 text-center headline'>
                                <div className='headline-icon'>
                                    {this.state.appData.iconImageUrl
                                        ? <><img src={this.state.appData.iconImageUrl} className="svg-icon" alt="..." /></>
                                        : (
                                            <svg viewBox="0 0 32.5 59" className="svg-icon">
                                                <path d="M31.63 30.836H.86a.865.865 0 0 0-.86.875v5.759a.879.879 0 0 0 .42.75l5.08 3.071L.51 57.872a.888.888 0 0 0 .13.774.872.872 0 0 0 .7.354h29.82a.87.87 0 0 0 .83-1.128L27 41.291l5.08-3.071a.879.879 0 0 0 .42-.75v-5.759a.873.873 0 0 0-.87-.875zm-1.64 26.415H2.51L7.04 42.22l8.76 5.292a.873.873 0 0 0 .9 0l8.76-5.292zm.78-20.277l-14.52 8.768-14.52-8.768v-4.388h29.04v4.388zm.86-27.27H.86a.865.865 0 0 0-.86.875v17.5a.865.865 0 0 0 .86.875h30.77a.873.873 0 0 0 .87-.875v-17.5a.873.873 0 0 0-.87-.879zm-.86 17.5H1.73v-15.75h29.04V27.2zm.86-27.2H.86A.864.864 0 0 0 0 .878v6a.864.864 0 0 0 .86.874h30.77a.873.873 0 0 0 .87-.874v-6A.872.872 0 0 0 31.63 0zm-.86 6H1.73V1.752h29.04V6z"></path>
                                            </svg>
                                        )
                                    }
                                </div>
                                <h1>{this.state.appData.title}</h1>
                            </div>
                        </div>
                        )
                        : ''
                    }

                    {this.state.start ? (
                        <div className='row'>
                            <div className='col-12 text-center intro-text' style={{minHeight:this.state.popHeight}}>
                                {this.state.dataLoaded ? (
                                    <>
                                        {parse(`${this.state.appData.introductionText}`)}
                                        {this.state.acceptTerms 
                                            ? <><button onClick={this.start} className='btn btn-brand mt-4'>{this.state.appData.productfinder_start}</button></>
                                            : <><button onClick={this.openPopUp} className='btn btn-brand mt-4'>{this.state.appData.productfinder_start}</button></>
                                        }
                                        {this.state.popUp === 'open' ? (
                                            <div className='popUp' ref={this.popup}>
                                                <div className='companyLogo'>
                                                {this.state.appData.logoImageUrl
                                                    ? <><img src={this.state.appData.logoImageUrl} className="svg-icon" alt="..." /></>
                                                    : (
                                                        <svg viewBox="0 0 141.5 37.5" className="svg-icon">
                                                            <path fill="#009FE3" d="M107.9,25.1h6.9V6.9h6.3V0.6h-19.5v6.3h6.3V25.1z M92.1,25.1h6.9V0.6h-6.9V25.1z M69.7,16.9 c0.1,7.8,7.3,8.8,9.9,8.8c5,0,10.4-2.1,10.4-8.5c0-4.5-3.2-6.1-6.3-7.1c-3.2-1-6.4-1.3-6.5-3.1c0-1.4,1.5-1.6,2.5-1.6 c0.7,0,1.5,0.2,2.1,0.6c0.6,0.4,0.9,1,0.8,2H89c-0.2-6-4.5-8-9.4-8c-4.6,0-9.1,2.4-9.1,8.1c0,4.9,4.1,6,7.6,7.1 c3.9,1.2,4.9,1.5,4.9,2.8c0,1.8-1.7,2.2-2.9,2.2c-1.3,0-2.8-0.3-3.3-1.8c-0.2-0.4-0.2-1-0.2-1.6H69.7z M46.3,25.1h7l1-3.5h7.2 l0.9,3.5h7.2L61.4,0.6h-6.8L46.3,25.1z M55.8,16.4l2.2-7.6H58l2,7.6H55.8z M24.4,25.1h6.9v-9.7h6.5v9.7h6.9V0.6h-6.9v8.5h-6.5V0.6 h-6.9V25.1z M20.3,9.1H0V0.6h20.3V9.1z M121.2,16.6h20.3v8.5h-20.3V16.6z"></path>
                                                        </svg>
                                                    )
                                                }
                                                </div>
                                                {parse(`${this.state.appData.popupText}`)}
                                                <button onClick={this.start} className='btn btn-brand'>{this.state.appData.productfinder_accept}</button>
                                            </div>
                                        ) : '' }
                                    </>
                                ):(
                                    <div className=''>
                                        {this.state.error 
                                            ? <div className='error-message'><p>&nbsp;</p><p>{this.state.appData.productfinder_error}</p></div>
                                            : ''
                                        }
                                        <div className="lds-ring">
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    ):(
                        <>
                            {!this.state.result ? (
                                <>
                                {this.state.dataTable.map((items,index) => {
                                    return (
                                        <div className='row answer-container' key={items.uid}>
                                            <Question title={items.title} />
                                            <div className="col-12 answer-items" style={divHeight}>
                                                <div className='row'>
                                                    {items._children.map((a,aIndex) => {
                                                        return (
                                                            <Answer 
                                                                key={a.uid}
                                                                index={aIndex}
                                                                hidden={a.hidden}
                                                                // onAdd={() => this.addQuestion(this.state.dataString +'[0][_children]['+ aIndex+'][_children]',a.uid)}
                                                                onAdd={() => this.addQuestion(a.pid, a.uid)}
                                                                title={a.title}
                                                                aUid={a.uid}
                                                                image={a.tx_fixitsitepackage_navimage} 
                                                                description={a.productfinder_description}
                                                                updateRowHeight={this.updateHeight}
                                                                link="next" />
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                                </>
                            ) : (
                                <>
                                <Result aUid={this.state.answer} view={this.state.view} changeView={this.updateView} host={this.props.host} pageUid={this.props.dataPid} appData={this.state.appData} ignoreParams={this.state.ignoreParams} />
                                {this.state.view === 'RD'
                                    ? (
                                        <>
                                            {this.state.path.length ? (
                                                <div className='col-12 path'>
                                                    <div className='header'>{this.state.appData.productfinder_qa_headline}</div>
                                                    {this.state.path.map((item,i) => {
                                                        return (
                                                            <div key={'qa'+i} className={'item '+ (i%2 ? ' even':' odd')}>
                                                                {item[2] === 'question'
                                                                    ? (
                                                                        <span className='path-question' onClick={() => this.jumpToQuestion(item[0], i/2)}>
                                                                            {item[3] === ''
                                                                                ? <>{item[1]} [{this.state.appData.productfinder_nav_question} {i/2 +1}]</>
                                                                                : <>{item[1]} [{item[3]}]</>
                                                                            }
                                                                        </span>
                                                                    ) : (
                                                                        <span className='path-answer'>
                                                                            {item[1]}
                                                                        </span>
                                                                    )
                                                                }
                                                            </div>
                                                        )})
                                                    }    
                                                </div>
                                            ) : ''
                                            }
                                        </>
                                    ) : ''
                                }
                                </>
                            )}
                        </>
                    )}

                    <div className='nav-container'>
                        {!this.state.start 
                            ? <button className="nav-btn" onClick={() => this.goToStart()}><span>{this.state.appData.productfinder_nav_home}</span></button>
                            : ''
                        }

                        {this.state.questions.length ? (
                                <>
                                    {this.state.questions.map((question,i) => {
                                        return (
                                                <button key={question[0]} className="nav-btn" onClick={() => this.jumpToQuestion(question[0], i)}>
                                                    <span>
                                                        <>
                                                        {question[3] === ''
                                                            ? <>{this.state.appData.productfinder_nav_question} {i+1}</>
                                                            : <>{question[3]}</>
                                                        }
                                                        </>
                                                    </span>
                                                    {/* {i === 0 ? (
                                                        <span>neu starten</span>
                                                    ) : (
                                                        <span>Frage {i+1}</span>
                                                    )} */}
                                                </button>
                                        )})
                                    }
                                    {this.state.view === 'RD' ? (
                                        <>
                                            <button className="nav-btn" onClick={() => this.changeView('RL')}>
                                                <span>{this.state.appData.productfinder_nav_backToResult}</span>
                                            </button>
                                        </>
                                    ) : ''}
                                </>
                            ) : ''
                        }
                        
                        {!this.state.start 
                            ? <button className='nav-btn active'></button>
                            : ''
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default App;
